// https://gist.github.com/jed/982883
export const secureRandom = (e) => {
  return e
    ? (e ^ (crypto.getRandomValues(new Uint8Array(1))[0] % 16 >> (e / 4))).toString(16)
    : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, secureRandom);
};

export const parseJwt = (token) => {
  var base64Url = token.split('.')[1];
  if (base64Url == null || base64Url == undefined) {
    return {};
  } else {
    var base64 = decodeURIComponent(
      atob(base64Url)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join(''),
    );

    return JSON.parse(base64);
  }
};

export const escapeHtml = (unsafe) => {
  return unsafe.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
};

export default {
  escapeHtml,
  parseJwt,
  secureRandom,
};
